// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--orbWK","close":"dd31006766--close--LKPjY","left":"dd31006766--left--iLd4m","title":"dd31006766--title--GDqUc","text":"dd31006766--text--CSq67"};